/**
 * Knowledge Source Icon Helper
 * Returns the appropriate icon for a knowledge source type
 */

import { Icon } from "@introist/react-foundation/v2";
import googleDrive from "../../assets/integrationIcons/google-drive.svg";

export const getKnowledgeSourceIcon = (type: string) => {
  switch (type) {
    case "google_drive":
      return <img src={googleDrive} alt="Google Drive" style={{ width: "100%", height: "100%" }} />;
    default:
      return <Icon name="folder" />;
  }
};
